import React from "react";
import { Box, IconButton } from "@mui/material";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const MessageMediaActions = ({
  onPickImage,
  onPickPdf,
  onReplaceMedia,
  onRemoveMedia,
  messageId,
  mediaKind,
  hasMedia = false,
  floating = false,
  readOnly = false,
}) => {
  const handlePickImage = () => {
    if (readOnly || typeof onPickImage !== "function") return;
    onPickImage(messageId);
  };

  const handlePickPdf = () => {
    if (readOnly || typeof onPickPdf !== "function") return;
    onPickPdf(messageId);
  };

  const handleReplace = () => {
    if (readOnly || typeof onReplaceMedia !== "function") return;
    onReplaceMedia(messageId, mediaKind);
  };

  const handleRemove = () => {
    if (readOnly || typeof onRemoveMedia !== "function") return;
    onRemoveMedia(messageId);
  };

  if (hasMedia) {
    return (
      <Box
        sx={{
          ...(floating
            ? {
                position: "absolute",
                top: 6,
                right: 6,
                zIndex: 2,
              }
            : {
                mb: 0.75,
              }),
          display: "flex",
          justifyContent: "flex-end",
          gap: 0.5,
        }}
      >
        <IconButton
          size="small"
          onClick={handleReplace}
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            backgroundColor: "#44484e",
            color: "#fff",
            "&:hover": { backgroundColor: "#3d4046" },
          }}
        >
          <AttachFileOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>

        <IconButton
          size="small"
          onClick={handleRemove}
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            backgroundColor: "#44484e",
            color: "#fff",
            "&:hover": { backgroundColor: "#3d4046" },
          }}
        >
          <DeleteOutlineOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        mb: 1,
        p: 0.75,
        borderRadius: 2,
        backgroundColor: "#d6dbe3",
        display: "flex",
        justifyContent: "center",
        gap: 1.1,
      }}
    >
      <IconButton
        size="small"
        onClick={handlePickImage}
        sx={{
          width: 46,
          height: 46,
          borderRadius: "50%",
          backgroundColor: "#b6c3d4",
          "&:hover": { backgroundColor: "#a7b7cb" },
        }}
      >
        <PhotoCameraOutlinedIcon sx={{ fontSize: 21, color: "#5f6f85" }} />
      </IconButton>

      <IconButton
        size="small"
        onClick={handlePickPdf}
        sx={{
          width: 46,
          height: 46,
          borderRadius: "50%",
          backgroundColor: "#b6c3d4",
          "&:hover": { backgroundColor: "#a7b7cb" },
        }}
      >
        <PictureAsPdfOutlinedIcon sx={{ fontSize: 21, color: "#5f6f85" }} />
      </IconButton>
    </Box>
  );
};

export default MessageMediaActions;
